import { InterviewResult } from '@recruitee/interview-results-types';
import { Placement } from '@recruitee/placements-types';

export interface RatingStats {
  evalCount: number;
  interviewerCount: number;
}

/**
 * Get the rating stats for a placement based on the interview results
 * @param placement
 * @param interviewResults
 */
export const getPlacementRatingStats = (
  placement: Placement,
  interviewResults: Record<number, InterviewResult[]>,
): RatingStats => {
  const ratingsForThisPlacement = Object.entries(interviewResults)
    .map(entry => {
      const [interviewerId, results] = entry;
      const currentPlacementResults = results.filter(
        result => result.offerId === placement.offerId && result.kind === 'rating',
      );
      return [interviewerId, currentPlacementResults];
    })
    .filter(([, results]) => results.length);
  return {
    evalCount: ratingsForThisPlacement.reduce((acc, results) => acc + results[1].length, 0),
    interviewerCount: ratingsForThisPlacement.length,
  };
};
